import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleToastMutation } from '@/helpers/toast';
import commonSlice from '@/redux/features/common.slice';
import { getIntegrationErrorMessage } from '../helpers';

interface UseConfigDraftParams {
  saved: Record<string, string>;
  resolve?: (values: Record<string, string>) => Record<string, string>;
  isSaving: boolean;
  save: (values: Record<string, string>) => Promise<unknown>;
}

const useConfigDraft = ({ saved, resolve = (values) => values, isSaving, save }: UseConfigDraftParams) => {
  const dispatch = useDispatch();
  const [draft, setDraft] = useState(saved);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => setDraft(saved), [saved]);

  const values = resolve(draft);

  const onSave = async () => {
    const res: any = await save(values);
    if (res?.data?.state === 1) {
      setIsEditing(false);
      dispatch(commonSlice.actions.handleToast(handleToastMutation(res)));
      return;
    }
    dispatch(commonSlice.actions.handleToast({ isOpen: true, content: getIntegrationErrorMessage(res), error: true }));
  };

  return {
    values,
    isSaving,
    isEditing,
    onEdit: () => setIsEditing(true),
    isDirty: JSON.stringify(values) !== JSON.stringify(resolve(saved)),
    onChange: (key: string, value: string) => setDraft((prev) => ({ ...prev, [key]: value })),
    onDiscard: () => {
      setDraft(saved);
      setIsEditing(false);
    },
    onSave,
  };
};

export default useConfigDraft;
